export const getApiOptions = async ({ apiClient }) => {
  const response = await apiClient.get(
    `/settings-api/options`,
  );
  return response.status === 200 ? response.data : null;
};